import { api } from '@/lib/axios';

export interface Overview {
  meetings: { total: number; live: number; scheduled: number; ended: number; avgDurationMins: number };
  users: { total: number; active: number; newLast30d: number };
  engagement: { totalParticipants: number; avgParticipantsPerMeeting: number; totalMinutes: number };
  storage: { recordings: number; totalBytes: number };
  revenue: { totalPaidCents: number; byPlan: { tier: string; count: number }[] };
}

export interface UserAnalytics {
  hostedMeetings: number;
  totalMinutes: number;
  recordings: number;
  totalParticipantsHosted: number;
}

export const analyticsApi = {
  async overview(): Promise<Overview> {
    const { data } = await api.get('/analytics/overview');
    return data.data;
  },
  async me(): Promise<UserAnalytics> {
    const { data } = await api.get('/analytics/me');
    return data.data;
  },
};
